export const ArticleParams = {

    limitsByResolution: {

        resolution_4963: {

            //artigos fora dos dois limites 18 e 19
            offLimitArt18And19Ids: [
                // 35, //4923
                // 60 //5272
            ],

            limiteArt18: 20,
            offLimitArt18Ids: [
                34, 35, //4923
                60, 61, 62 //5272
            ],

            //Limite do artigo 18 por legislation_article_id, quando diferente de limiteArt18
            //Art. 7º I (FI Renda Fixa Referenciado 100% títulos TN) possui limite de 100%
            limitArt18ById: {
                35: 100, //4923
                60: 100, //5272
            },

            limiteArt19: 15,
            extraLimiteArt19: 5,
            fullOffLimitArt19: [
                35, //4923
                60 //5272
            ],
            offLimitArt19Ids: [
                41, 42, 43, //4923
                66, 67, 68 //5272
            ], //Em caso de FIDCs, FI Renda Fixa “Crédito Privado” e FI “Debêntures”, o limite é de 5% do patrimônio líquido do fundo

            //Limite do artigo 19 por legislation_article_id, quando diferente de limiteArt19
            //Art. 7º VII, VIII e IX possuem limite de 5% do patrimônio líquido do fundo
            limitArt19ById: {
                41: 5, 42: 5, 43: 5, //4923
                66: 5, 67: 5, 68: 5, //5272
            },

            limiteArt20: 5,

            limiteArt21: 50,

        }

    },


}